module.exports = __webpack_public_path__ + "static/media/notebook.424b3291.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/notebook.svg
// module id = 1298
// module chunks = 0